import * as APIRoutes from '@mm/api-routes';
import { ObjectUtils } from '@mm/utils';
import {
  CreateTriggerParams,
  RetrieveAllParams,
} from '../actions/TriggerCRUDActions';
import TriggerModel from '../model/TriggerModel';
import { Pagination } from '../store-interfaces';
import AuthenticatedController from './AuthenticatedController';

export default class TriggerController extends AuthenticatedController {
  static async getAll(
    retrieveAllParams: RetrieveAllParams,
  ): Promise<{ triggers: TriggerModel[]; pagination?: Pagination }> {
    const params = ObjectUtils.mapObjKeysToSnakeCase(retrieveAllParams);

    const response = await super.get(APIRoutes.TRIGGER, params);

    if (!response.triggers) {
      return {
        triggers: response,
      };
    }

    const { triggers, pagination } = response;
    return {
      triggers,
      pagination,
    };
  }

  static getById(triggerId: number): Promise<TriggerModel | undefined> {
    return super.get(`${APIRoutes.TRIGGER}/${triggerId}`);
  }

  static async postTrigger(entity: CreateTriggerParams): Promise<TriggerModel> {
    const response = await super.post(APIRoutes.TRIGGER, entity);
    return response.trigger;
  }

  static async putTrigger(
    entity: Partial<TriggerModel>,
  ): Promise<TriggerModel> {
    const response = await super.put(
      `${APIRoutes.TRIGGER}/${entity.id}`,
      entity,
    );
    return response.trigger;
  }

  static deleteTrigger(triggerId: number): Promise<any> {
    return super.delete(`${APIRoutes.TRIGGER}/${triggerId}`);
  }
}
